export const BRAND = { navy: "#16294A", red: "#D7263D", coral: "#FF7A8A" };

export const BrandIcon = ({ size = 36, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={BRAND.red} />
    <path d="M9 34h9l4-8 6 16 6-24 4 16h4" fill="none" stroke="#fff" strokeWidth="4.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M46 24.5a11 11 0 0 1 0 15" fill="none" stroke="#fff" strokeWidth="3.6" strokeLinecap="round" />
    <path d="M51.5 20a17.5 17.5 0 0 1 0 24" fill="none" stroke="#fff" strokeWidth="3.6" strokeLinecap="round" />
  </svg>
);

export function BrandLogo({ tone = "light", size = 34, tagline = false, className = "", testid = "brand-logo" }) {
  const word = tone === "light" ? BRAND.navy : "#fff";
  return (
    <span className={`inline-flex items-center gap-2.5 select-none ${className}`} data-testid={testid}>
      <BrandIcon size={size} />
      <span className="leading-none">
        <span className="font-extrabold tracking-[-0.04em]" style={{ fontFamily: "Sora, sans-serif", color: word, fontSize: size * 0.68 }}>bsafe</span>
        <span className="font-semibold" style={{ fontFamily: "Sora, sans-serif", color: tone === "light" ? BRAND.red : BRAND.coral, fontSize: size * 0.38 }}>.today</span>
        {tagline && <span className="block mt-1 font-semibold tracking-[0.28em]" style={{ color: tone === "light" ? "#64748B" : "#CBD5E1", fontSize: Math.max(8, size * 0.2) }}>EVERY SECOND COUNTS</span>}
      </span>
    </span>
  );
}
